import Header from 'Components/Header/Header'

export default Header